export default `---
slug: term-deposit-marketing
title: "Term-deposit Marketing"
year: 2023
category: personal
featured: false
tags: [Python, XGBoost, Imbalanced Data, Feature Engineering, Apziva]
thumbnail: /images/projects/14_vecho_XGBoos_CV.png
description: "Predicting the success of telephone marketing campaigns with XGBoost and randomized search CV — tackling imbalanced datasets head-on."
relatedLinks:
  - label: "Apziva Data Science Bootcamp"
    href: /career/apziva-bootcamp
---

This is the second project I did with [Apziva](https://www.apziva.com/), a Data Science bootcamp that I attended for the most part of 2023.
Apziva provided me the dataset for the project, and a mentor whom I would have weekly meetings with, to support my progress. Except for Bhargav (my mentor), I did everything alone, *and with ChatGPT, who am I kidding*.

This project ([GitHub repo](https://github.com/Ilvecho/Term-Deposit-Marketing)) was again a Binary Classification problem, in which we had to predict the success of a telephone marketing campaign based on the data of the contacted person.

![Student in NL doing XGBoost and CV](/images/projects/14_vecho_XGBoos_CV.png)

- First, I performed preliminary analysis on the data to understand the underlying information available
- Then, I looked into feature engineering on both continuous and categorical data to enhance the information availability
- The dataset available was highly unbalanced, so I explored different options to deal with it
- As a model, I picked XGBoost for its known performance, and I performed Randomized Search CV for hyperparameters tuning
- Finally, I evaluated the model performance with 5-fold CV and hit the target performance level

Of course this project was done in Python: I used plotly for data visualization and pandas for feature engineering, and the omnipresent sklearn for model evaluation and selection.
I would love to tell you more about the project, but I don't really remember and I am too lazy to check the Jupyter notebook - it is linked at the top, if you are curious go check it out!
`;
